import { nsD, nsDfs, nsPc, nsQ } from '@qdabra/forms-shared/xmlNamespaces';
import { map } from "ramda";
import { namespaceCmeData } from "../../formsviewer/constants.namespaces";

import { 
    makeDfsElement,
    makeQElement,
 } from "../../xml/element.builders";


const getBaseXmlString = (isListForm) =>
    `<dfs:myFields
        xmlns:d="${nsD}"
        xmlns:q="${nsQ}"
        xmlns:dfs="${nsDfs}"
        xmlns:pc="${nsPc}"
        ${isListForm ? `xmlns:my="${namespaceCmeData}"` : ''}
    />`;

const buildQueryFieldsRow = (dom, fields) =>
    makeQElement(dom, 'SharePointListItem_RW', {
        children: map(
            ({ internalName }) => makeQElement(dom, internalName),
            fields,
        ),
    });

const buildQueryFields = (dom, fields) =>
    makeDfsElement(dom, 'queryFields', {
        children: [buildQueryFieldsRow(dom, fields)],
    });

const buildBaseXml = (fields, isListForm) => {
    const dom = $.parseXML(getBaseXmlString(isListForm));
    let myFields = dom.documentElement;

    myFields.appendChild(buildQueryFields(dom, fields));
    myFields.appendChild(makeDfsElement(dom, 'dataFields'));

    return dom;
};

export default buildBaseXml;
